export enum OAuth2Cookies {
  AccessToken = 'bf-brandguide-access-token',
  RefreshToken = 'bf-brandguide-refresh-token'
}

export enum OAuth2Keys {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Host = 'host',
  State = 'state',
  UpdatedAt = 'updatedAt'
}
